"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSystemState = void 0;
const react_1 = require("react");
function useSystemState(system) {
    return (0, react_1.useSyncExternalStore)(cb => system.hook(cb), () => system.snapshot());
}
exports.useSystemState = useSystemState;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU3lzdGVtU3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlU3lzdGVtU3RhdGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlDQUE2QztBQUk3QyxTQUFnQixjQUFjLENBQUMsTUFBcUM7SUFDbEUsT0FBTyxJQUFBLDRCQUFvQixFQUN6QixFQUFFLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQ3JCLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsQ0FDeEIsQ0FBQztBQUNKLENBQUM7QUFMRCx3Q0FLQyJ9